import React from "react";

function ProjectorSvg() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
     <path d="M12 0C12.32 0 12.6047 0.203007 12.7091 0.505507L13.5692 3H21C21.8284 3 22.5 3.67157 22.5 4.5V15C22.5 15.8284 21.8284 16.5 21 16.5H18.2244L20.2091 22.2555C20.3441 22.6471 20.1361 23.074 19.7445 23.209C19.3529 23.3441 18.926 23.1361 18.791 22.7445L16.6377 16.5H12.75V21C12.75 21.4142 12.4142 21.75 12 21.75C11.5858 21.75 11.25 21.4142 11.25 21V16.5H7.36232L5.20905 22.7445C5.07402 23.1361 4.64711 23.3441 4.25553 23.209C3.86394 23.074 3.65596 22.6471 3.79099 22.2555L5.77565 16.5H3C2.17157 16.5 1.5 15.8284 1.5 15V4.5C1.5 3.67157 2.17157 3 3 3H10.4308L11.291 0.505507C11.3953 0.203007 11.68 0 12 0ZM3 4.5V15H21V4.5H3Z" />
     <path d="M12 0C12.32 0 12.6047 0.203007 12.7091 0.505507L13.5692 3H21C21.8284 3 22.5 3.67157 22.5 4.5V15C22.5 15.8284 21.8284 16.5 21 16.5H18.2244L20.2091 22.2555C20.3441 22.6471 20.1361 23.074 19.7445 23.209C19.3529 23.3441 18.926 23.1361 18.791 22.7445L16.6377 16.5H12.75V21C12.75 21.4142 12.4142 21.75 12 21.75C11.5858 21.75 11.25 21.4142 11.25 21V16.5H7.36232L5.20905 22.7445C5.07402 23.1361 4.64711 23.3441 4.25553 23.209C3.86394 23.074 3.65596 22.6471 3.79099 22.2555L5.77565 16.5H3C2.17157 16.5 1.5 15.8284 1.5 15V4.5C1.5 3.67157 2.17157 3 3 3H10.4308L11.291 0.505507C11.3953 0.203007 11.68 0 12 0ZM3 4.5V15H21V4.5H3Z" />
    </svg>
  );
}

export default ProjectorSvg;
